import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';

const getWindow = (): any => {
  return window;
};

@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  isBrowser: boolean;

  constructor(private platform: Platform) {
    this.isBrowser =
      this.platform.isBrowser && window?.localStorage !== undefined;
  }

  get nativeWindow(): Window | undefined {
    if (this.isBrowser) {
      return getWindow();
    } else {
      return undefined;
    }
  }
}
